<template>
    <app-content-admin>
      <template slot="header">View Segmentation Details</template>
      <template slot="button">
        <v-btn
          style="margin-left: auto"
          large
          color="secondary"
          to="/segmentation"
        >
          Back
        </v-btn>
      </template>
  
      <v-layout row no-wrap>
        <v-flex xs12 lg12 mx-auto>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('Segmentation Name')"
                      v-model="form.segmentation_name"
                      :rules="[rules.required('Segmentation Name')]"
                      outlined
                    ></v-text-field>
               
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

          <!-- File Input Row -->
          <v-layout row wrap>
            <v-flex xs12>
              <div class="input-container">
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileUpload"
                  accept=".csv, .xlsx, .xls"
                  class="custom-file-input"
                />
              </div>
            </v-flex>
          </v-layout>


     
            <v-card-actions class="d-flex align-center justify-center">
          
              <v-btn color="primary" @click="updateSegmentation" class="form-submit ">
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 lg12 mx-auto>
        <v-card class="p-3">
          <table class="table table-fluid no-wrap">
            <thead>
              <th scope="col">No</th>
              <th scope="col">Email</th>
            </thead>
            <tbody>
         
              <tr v-for="(email, index) in form.emails" :key="index">
                <td>{{ index+1 }}</td>
                <td :data-label="$t('Email')">
                  {{ email }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-flex>
      </v-layout>
    </app-content-admin>
  </template>
  
  <script>
  import vForm from "@/mixins/vForm";
  import ActiveLabel from "../../components/status/ActiveLabel.vue";
  import store from "@/store";
  import router from "../../router";
  
  export default {
    mixins: [vForm],
  
    data() {
      return {
        project_list: [],
        form: {
          id_segmentation: null,
          segmentation_name: null,
          emails:null,
        },
        showpass: false,
      };
    },
  
    components: { ActiveLabel },
  
    created() {
      this.form.id_segmentation = this.$route.params.id;
  
      this.getSegmentation();
    },
  
    methods: {
      //Update Specific user data
      async updateSegmentation() {
        let loader = this.$loading.show();
   
        try {
          let formData = new FormData();
        formData.append("segmentation_name", this.form.segmentation_name);
        formData.append("file", this.selectedFile); // Use the selected file here
        console.log("id segment",this.form.id_segmentation);
        formData.append("id_segmentation",this.form.id_segmentation);

        console.log("File",this.selectedFile)

        let res = await axios.post("/api/auth/update_segmentation", formData, {
             headers: {
                  "Content-Type": "multipart/form-data", // Set the correct content type
               },
        });

          if (res.status == 200) {
            console.log("Update",res);
            console.log("Segmentation Update Success", res);
            this.$toastr.s("Segmentation update successfully");
            router.push("/segmentation");
          }
        } catch (err) {
          if (err.response.status === 400) {
            // Validation errors returned by the server
            // this.$toastr.e("Please input all required data");
          } else {
            // this.$toastr.e("An error occurred while creating the AdZone.");
            console.log("Error create template", err);
          }
        } finally {
          loader.hide();
        }
      },


      
   
  
      //Read specific user data
      async getSegmentation() {
        let loader = this.$loading.show();
  
        try {
          let res = await axios.get(`/api/auth/get_segmentation`, {
            params: { id_segmentation: this.form.id_segmentation },
          });

          
  
          if (res.status == 200) {
            //  const templateData = res.data.result.template;
             console.log("dog",res.data.data.result.emails)
             this.form.id_segmentation=this.$route.params.id;
             this.form.segmentation_name =res.data.data.result.segmentation_name;
             this.form.emails =res.data.data.result.emails;
        
          }
        } catch (err) {
          //  this.$toastr.e(err.response.data.message);
          console.log("Get specific segmentation data fail");
        } finally {
          loader.hide();
        }
      },

      handleFileUpload(event) {
      // Store the selected file in the data property
      this.selectedFile = event.target.files[0];
      console.log("this file", this.selectedFile);
    },
    },
  };
  </script>

  <style>

.input-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.custom-file-input {
  font-size: 18px;
  padding: 15px;
  border: 2px solid #4caf50;
  border-radius: 8px;
  background-color: #f2f2f2;
  color: #333;
}

.custom-file-input:hover {
  border-color: blueviolet;
}







  
  </style>
  